import { showToast } from './utils.js';

export const SESSION_HINT_KEY = 'mysky_session';

/** Remember a recent successful auth so home does not flash the login gate. */
export function markSessionHint() {
  try { sessionStorage.setItem(SESSION_HINT_KEY, '1'); } catch { /* ignore */ }
}

export function clearSessionHint() {
  try { sessionStorage.removeItem(SESSION_HINT_KEY); } catch { /* ignore */ }
  try { document.documentElement.classList.remove('mysky-auth-pending'); } catch { /* ignore */ }
}

/** Run synchronously in boot.js before paint when a session hint exists. */
export function applySessionHintUi() {
  try {
    if (sessionStorage.getItem(SESSION_HINT_KEY) === '1') {
      document.documentElement.classList.add('mysky-auth-pending');
    }
  } catch { /* ignore */ }
}

/** Register a global handler for expired sessions (used by api.js). */
export function installSessionHandler(opts = {}) {
  const redirect = opts.redirect ?? '/';
  const message = opts.message ?? 'Session expired — please sign in again';
  const on401 = opts.on401;
  window.__myskyOn401 = () => {
    clearSessionHint();
    if (message) showToast(message, 'warning');
    if (typeof on401 === 'function') on401();
    else if (redirect) location.href = redirect;
  };
}
